module.exports = __webpack_public_path__ + "files/c92b9c5c35faf6db26bdd104be73f7f4.png";